export const PEOPLE_PIC_URL_PREFIX = 'https://ak-static.cms.nba.com/wp-content/uploads/headshots/nba/latest/260x190';
export const TEAM_PIC_URL_PREFIX = 'https://stats.nba.com/media/img/teams/logos';
export const DEFAULT_SEARCH_PLAER = 'Lebron James';
export const DEFAULT_COMPARE_PLAYER = "Stephen Curry";
export const SHOOTING_ZONE_RC  = "Right Side Center(RC)";
export const SHOOTING_ZONE_LC  = "Left Side Center(LC)";
export const SHOOTING_ZONE_CT  = "Center(C)";
export const SHOOTING_ZONE_L  = "Left Side(L)";
export const SHOOTING_ZONE_R  = "Right Side(R)";
export const PLAYER_ONE_INDEX = 0;
export const PLAYER_TWO_INDEX = 1;
export const MERGED_GRAPH_MIN_COUNT = 4;
export const ADD_PLAYER_ACTION = "add player";
export const REMOVE_PLAYER_ACTION = "remove player";
export const INIT_PLAYER_ACTION = "init";
export const UPDATE_PLAYER_ACTION = "modify";
